var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cy-class"},[_vm._v("创业有风险 投资需谨慎")])}
var staticRenderFns = []

export { render, staticRenderFns }